export const APIPrefix = "/api";
